// THIS IS TIME SLICE WHICH WE USE IN QUIZ GAME FOR SHOWING THE TIME 

import { createSlice } from "@reduxjs/toolkit";

const initialState = { timeClock: 60, timeForProgress: 1, progress: 100 };

const timeSlice = createSlice({
    name: "time",
    initialState,
    reducers: {
        DecreaseTime: (state, action) => {
            state.timeClock = state.timeClock - 1;
            return state;
        },
        ResetTime: (state, action) => {
            state.timeClock = 60;
            state.timeForProgress = 1;
            state.progress=100;
            return state;
        },
        IncreaseTimeForProgress: (state, action) => {
            state.timeForProgress = state.timeForProgress + 1;
            return state;
        },
        SetProgress: (state, action) => {
            // state.progress = -1 * (state.timeForProgress * 3.34 - 100);
            state.progress = -1 * (state.timeForProgress * 1.67 - 100);
            return state;
        },
    },
});
export const {
    DecreaseTime,
    ResetTime,
    IncreaseTimeForProgress,
    SetProgress,
} = timeSlice.actions;
export default timeSlice;